/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 33
// module chunks = 0